// Programme timeline data for the Agenda section. Edit times/copy here.
export const AGENDA_ITEMS = [
  {
    time: "6:30PM",
    datetime: "2026-10-01T18:30:00+08:00",
    title: "Registration & Refreshments",
    description: "Arrive early, settle in and meet the team.",
    detail:
      "Come a little early to check in, grab a drink and get comfortable. Our team will be on hand to welcome you and answer any quick questions before we begin.",
    takeaway: "A relaxed start and a friendly face before things get underway.",
  },
  {
    time: "7:00PM",
    datetime: "2026-10-01T19:00:00+08:00",
    title: "CPF & Your Retirement",
    speaker: "Angeline Teo (CPF Board)",
    description: "What happens at 55, BRS/FRS/ERS and CPF LIFE — straight from CPF Board.",
    detail:
      "An official CPF Board representative walks through what actually happens to your CPF at 55, what the Basic, Full and Enhanced Retirement Sums mean, how CPF LIFE and its three plans work, and the latest CPF updates as of 2026.",
    takeaway: "A clear, up-to-date picture of what happens to your CPF at each milestone.",
  },
  {
    time: "7:45PM",
    datetime: "2026-10-01T19:45:00+08:00",
    title: "Refine Your Retirement Portfolio",
    speaker: "Nicholas Lee (Affinity Group)",
    description: "How CPF complements the rest of your retirement plan.",
    detail:
      "Retirement could last 30 or 40 years. Using relatable examples, Nicholas shows how CPF withdrawals, CPF LIFE payouts and payout timing fit alongside your other savings, so your income keeps going long after your salary stops.",
    takeaway: "Confidence that CPF and your other savings are working together.",
  },
  {
    time: "8:30PM",
    datetime: "2026-10-01T20:30:00+08:00",
    title: "Investing for the Long Term: Opportunities Across Global Equities",
    speaker: "Suyin Tan (Capital Group)",
    description: "Growing your wealth over the long term with CPF OA-approved global equity strategies.",
    detail:
      "Suyin introduces two of Capital Group's CPF OA-approved strategies, the New Economy Fund and the New Perspective Fund. Both are global equity strategies designed with a focus on long-term capital growth and wealth accumulation, rather than income generation or dividends. Hear where the opportunities are across global equities and how a long-term approach can complement your CPF.",
    takeaway: "A clearer view of how long-term global equity investing can sit alongside your CPF.",
  },
  {
    time: "8:45PM",
    datetime: "2026-10-01T20:45:00+08:00",
    title: "Live Q&A",
    tag: "Open Panel Discussion",
    description: "Ask the questions that matter to you and your family.",
    detail:
      "Bring your own questions. This is your chance to get clarity on the specific details that matter to you and your family — in a relaxed, no-jargon setting.",
  },
];
